import {
  GetCodigosEmpleado,
  PostCodigoEmpleado,
  PostEnviarComunicado
} from "../../reducers/codigosEmpleado";

export interface CodigoEmpleadoAdminStore
  extends GetCodigosEmpleado,
    PostCodigoEmpleado,
    PostEnviarComunicado {}

export const codigoEmpleadoAdminStore: (
  state
) => CodigoEmpleadoAdminStore = state => {
  const { codigosEmpleado } = state;
  return {
    codigosEmpleado: codigosEmpleado.codigosEmpleado,
    gettingCodigosEmpleado: codigosEmpleado.gettingCodigosEmpleado,
    gettingCodigosEmpleadoError: codigosEmpleado.gettingCodigosEmpleadoError,
    postingCodigoEmpleado: codigosEmpleado.postingCodigoEmpleado,
    postingCodigoEmpleadoError: codigosEmpleado.postingCodigoEmpleadoError,
    postingEnviarComunicado: codigosEmpleado.postingEnviarComunicado,
    postingEnviarComunicadoError: codigosEmpleado.postingEnviarComunicadoError
  };
};
